var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgALogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "188.602168px",
    height: "173.5px",
    viewBox: "0 0 188.602168 173.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Appice-Logo_new",
    transform: "translate(-20.000000, -34.500000)",
    fill: "#418AFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.425087,34.5 L208.602168,208 L178.562085,208 L168.032572,182.067616 L120.34007,182.067616 L106.094257,208 L20,208 L83.7964641,34.5 L145.425087,34.5 Z M114.45593,34.5 L61.1889792,181.141459 L107.642715,181.141459 L122.507911,155.517794 L158.122442,155.517794 L114.45593,34.5 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgALogo);
export default __webpack_public_path__ + "static/media/ALogo.761b50e2e7845dc5308cd40494ddbc8e.svg";
export { ForwardRef as ReactComponent };